module.exports = __webpack_public_path__ + "media/apps/main/containers/portfolio/Export/Docx/assets/icons/incomplete-7dbbe01e8d2bc5147d2251ee460d0926.svg";